import { CompanyOptionModelDto as BackOfficeCompanyOptionModelDto } from '@treasury/api/bo';
import { CompanyOptionModelDto as ChannelCompanyOptionModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

type CompanyOptionModelDto = ChannelCompanyOptionModelDto | BackOfficeCompanyOptionModelDto;
export class CompanyOptionModel extends DomainEntity<CompanyOptionModelDto> {
    constructor(dto: CompanyOptionModelDto) {
        super(dto);
        this.name = dto.name;
        this.value = dto.value;
    }

    public name?: string;

    public get value() {
        return this.dto.value;
    }

    public set value(value: string | undefined) {
        this.dto.value = value;
    }

    public createDefault(): this {
        return new CompanyOptionModel({
            name: '',
            value: '',
        }) as this;
    }
}
